/**
 * A game page opened from a challenge link (/games/<slug>?c=<id>) shows the
 * score to beat in a strip above the board. The stage gives up the strip's
 * height (--challenge-h, game-play.css), so the board still fits the screen.
 */

import { activeChallenge, fetchChallenge, setActiveChallenge } from './challenge-client.js';
import { challengeHeadline, ruleFor } from './challenge-rules.js';
import { currentGameSlug } from './feedback-client.js';
import { iconSvg } from './icons.js';

function clearFromAddress(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('c');
  window.history.replaceState(window.history.state, '', url);
}

function dismiss(banner: HTMLElement): void {
  banner.remove();
  document.documentElement.style.removeProperty('--challenge-h');
  setActiveChallenge(null);
  clearFromAddress();
}

async function init(): Promise<void> {
  const id = new URLSearchParams(window.location.search).get('c');
  const game = currentGameSlug();
  const stage = document.getElementById('stage');
  if (!id || !game || !stage) return;

  const challenge = await fetchChallenge(id);
  if (!challenge || challenge.game !== game) {
    clearFromAddress();
    return;
  }
  setActiveChallenge(challenge);
  if (!activeChallenge(game)) return;

  const gameName = document.querySelector('.pp-title')?.textContent?.trim() || game;
  const banner = document.createElement('aside');
  banner.className = 'challenge-banner';
  banner.setAttribute('aria-label', 'Challenge');
  banner.innerHTML = `
    <span class="challenge-banner-icon">${iconSvg('target')}</span>
    <span class="challenge-banner-text">
      <strong class="challenge-banner-title"></strong>
      <span class="challenge-banner-mode"></span>
    </span>
    <button type="button" class="challenge-banner-close" aria-label="Dismiss the challenge">
      ${iconSvg('x')}
    </button>`;
  const title = banner.querySelector('.challenge-banner-title');
  const mode = banner.querySelector('.challenge-banner-mode');
  if (title) title.textContent = challengeHeadline(challenge, gameName);
  if (mode) mode.textContent = `A friend's run · ${ruleFor(challenge.game, challenge.mode)?.label ?? ''}`;
  banner.querySelector('.challenge-banner-close')?.addEventListener('click', () => dismiss(banner));

  stage.before(banner);
  document.documentElement.style.setProperty('--challenge-h', `${banner.offsetHeight + 10}px`);
}

void init();
